export default __webpack_public_path__ + "935f95dd6e6eed6a02c1c7ebdf512e41.twig";